import { Form, Modal } from "antd";
import React from "react";
import { CreateInfluenceObjectDto } from "../../../api";
import { InfluenceObjectColumns } from "../form/columns";

interface InfluenceObjectFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateInfluenceObject: (values: CreateInfluenceObjectDto) => void;
}

export const InfluenceObjectForm: React.FC<InfluenceObjectFormProps> = ({ visible, setVisible, onCreateInfluenceObject }) => {
  const [form] = Form.useForm<CreateInfluenceObjectDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateInfluenceObject}>
        {InfluenceObjectColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
